export default "__VITE_ASSET__8653f79a__"